import { createAction } from 'typesafe-actions';

import {
  GetMobilePrinterListPayload,
  SetMobilePrinterListPayload,
  MobilePrinterErrorPayload,
} from './mobilePrinter.types';

export const getMobilePrinterList = createAction('GET_MOBILE_PRINTER_LIST')<GetMobilePrinterListPayload>();

export const setMobilePrinterList = createAction('SET_MOBILE_PRINTER_LIST')<SetMobilePrinterListPayload>();

export const mobilePrinterListError = createAction('MOBILE_PRINTER_LIST_ERROR')<MobilePrinterErrorPayload>();

export const resetMobilePrinter = createAction('CLEAR_MOBILE_PRINTER')();
